'use client'

import { IChildrenProps } from '@/utils/typings/children-props'
import { createContext, useContext } from 'react'
import {
    DirectoryContextProvider,
    IDirectoryContextProviderProps,
} from '@/features/drive/entities/directory/directory-context'
import { Route } from '@/setup/routing/routing'
import { IDirectorySelectionContextProviderProps } from '@/features/drive/functionalities/selection/directory-selection-context'
import { useFileLabelSubscription } from '@/api/drive/use-file-label-subscription'

interface IDriveContext {
    baseRoute: typeof Route.DRIVE
}

const DriveContext = createContext<IDriveContext>({} as IDriveContext)

type IDriveContextProviderProps = IChildrenProps & {
    directory: IDirectoryContextProviderProps
    selection?: IDirectorySelectionContextProviderProps
}

export const DriveContextProvider = ({ children, directory, selection }: IDriveContextProviderProps) => {
    // Subscribe to file label updates to refresh the drive when labels are auto-applied
    useFileLabelSubscription()

    return (
        <DriveContext.Provider value={{ baseRoute: Route.DRIVE }}>
            <DirectoryContextProvider {...directory} selection={selection}>
                {children}
            </DirectoryContextProvider>
        </DriveContext.Provider>
    )
}

export const useDriveContext = () => useContext(DriveContext)
